import styled from "@emotion/styled";
import { ExButton } from "@energyx-dev/energyx-ui";
import { totalServices } from "components/terms/helper";
import { useToggle } from "hooks/useToggle";
import { FormProvider, useForm } from "react-hook-form";
export const TermsHeader = () => {
  const methods = useForm();
  const { closeToggle, handleOnToggle, isOpenToggle, targetRef } = useToggle<HTMLUListElement>(100);

  const handleOnclickServiceLink = (path?: string) => {
    window.open(path);
    closeToggle();
  };
  return (
    <Layout>
      <FormProvider {...methods}>
        <header>
          <h5>에너지엑스 서비스 정책</h5>
          <div className="show_total_service_btn">
            <ExButton
              size="large"
              variant="contents"
              label="전체 서비스 보기"
              icon={isOpenToggle ? "chevron_direction_up" : "chevron_direction_down"}
              iconPosition="right"
              labelColor={"#2D2D2D"}
              iconColor={"#2D2D2D"}
              onClick={handleOnToggle}
            />
            <TotalServiceList ref={targetRef}>
              {totalServices.map((service, i) => (
                <li
                  key={i}
                  onClick={() => handleOnclickServiceLink(service.path)}
                  role="presentation"
                >
                  {service.label}
                </li>
              ))}
            </TotalServiceList>
          </div>
        </header>
      </FormProvider>
    </Layout>
  );
};

const Layout = styled.div`
  border-bottom: 1px solid #dbdbdb;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1080px;
    margin: 0 auto;
    padding: 17.5px 0;

    h5 {
      font-size: 18px;
      font-weight: 700;
      line-height: 25px;
      letter-spacing: -0.25px;
    }

    .show_total_service_btn {
      position: relative;
    }
  }

  ${({ theme }) => theme.breakpoints.down("TABLET")} {
    header {
      justify-content: center;
      padding: 12.5px 16px;
    }
    .show_total_service_btn {
      display: none;
    }
  }
`;

const TotalServiceList = styled.ul`
  position: absolute;
  height: 0;
  margin-left: 16px;
  width: 142px;
  border-width: 0;
  overflow: hidden;
  background-color: white;
  transition: height 0.2s ease;

  li {
    padding: 6px 8px;
    border: 1px solid #ececec;
    border-bottom: none;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
  }

  > li:last-of-type {
    border-bottom: 1px solid #ececec;
  }
`;
